import { PagedSearch } from '../../../../shared/model/paged-search.model';
export class UnappliedPaymentSearchDto extends PagedSearch {
  ProfileId: number;

  constructor() {
    super();
    this.OrderBy = 'PaymentDate';
  }
}
